import Vue from 'vue'
import Vuex from 'vuex'
import { userKey, urlSignal } from '@/config/global'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // variaveis globais
        user: null,
        hubConection: null,
        isAdmContrato: false,
        tpPessoa: null,
    },
    getters: {
        // get das variaveis
        
        getUser(state) {
            return state.user;
        },

        getHubConection(state) {
            return state.hubConection;
        },

    },
    mutations: {
        // troca valores das variaveis
        setUser(state, user) {
            state.user = user
            if (user) {
                localStorage.setItem(userKey, JSON.stringify(user))
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`

                state.isAdmContrato = user.usuario.isAdmContrato;
                state.tpPessoa = user.usuario.tpPessoa;

                var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + user.usuario.dsLogin, { accessTokenFactory: () => user.accessToken }).build();
                state.hubConection = connection;
                state.hubConection.start().then(function () {
                    //console.log('Connetado!');
                }).catch(function (err) {
                    return console.error('Erro: ', err.toString());
                });

                state.hubConection.onclose(async () => {
                    setTimeout(function () {
                        console.log('Tentando Reconectar!');
                        state.hubConection.start();
                    }, 5000);
                });
            } else {
                localStorage.removeItem(userKey)
                delete axios.defaults.headers.common['Authorization']

                state.hubConection = null;
            }
            
        },

        setUsuario(state, usuario) {
            if (state.user) {
                state.user.usuario = usuario
            }
        },

        setHubConection(state,n_conection) {
            state.hubConection = n_conection
        },

    },
    actions: {
        // logicas de trocar valores
        
    }
});

export default store;